<template>
  <div ref="printContent" class="print-container">
    <div class="print-content">
      <Watermark />
      <section
        dir="rtl"
        style="
          font-size: 18px;
          font-family: 'Arial', 'Tahoma', 'Segoe UI', sans-serif;
          background-color: transparent;
        "
        class="font-modify m-5"
      >
        <h1
          class="text-center text-dark mb-2"
          style="
            font-family: 'Arial', 'Tahoma', 'Segoe UI', sans-serif;
            background-color: transparent;
            padding: 10px;
          "
        >
          {{ $brand.nameArFull }}
        </h1>
        <h4
          class="text-center text-dark"
          style="
            font-family: 'Arial', 'Tahoma', 'Segoe UI', sans-serif;
            background-color: transparent;
            padding: 10px;
          "
        >
          الموضوع / تعهد
        </h4>
        <div
          class="mx-2 text-dark mt-4"
          dir="rtl"
          style="
            font-family: 'Arial', 'Tahoma', 'Segoe UI', sans-serif;
            background-color: transparent;
            padding: 15px;
          "
        >
          <p
            style="
              background-color: transparent;
              line-height: 2.2;
              text-align: right;
              font-family: 'Arial', 'Tahoma', 'Segoe UI', sans-serif;
              font-size: 16px;
              margin-bottom: 30px;
            "
          >
            أني الموقّع أدناه أتعهد بتنظيم بيان الولادة خلال فترة عشرة أيام من
            تاريخ الولادة، وخلال ساعات الدوام الرسمي للمستشفى من الساعة الثامنة
            صباحاً ولغاية الساعة الثالثة ظهراً. وأقرّ بأنني أتحمل كافة التبعات
            القانونية ولا يحق لي مطالبة المستشفى ببيان الولادة بعد التوقيع على
            هذا التعهد.
          </p>

          <div
            class="my-5 d-flex flex-column"
            style="background-color: transparent; padding: 20px 10px"
          >
            <div
              class="d-flex justify-content-between mb-4"
              style="background-color: transparent"
            >
              <section style="min-width: 200px">
                <p
                  style="
                    font-family: 'Arial', 'Tahoma', 'Segoe UI', sans-serif;
                    background-color: transparent;
                    margin-bottom: 40px;
                    font-size: 16px;
                  "
                >
                  التوقيع:
                  ......................................................
                </p>
              </section>
            </div>

            <div
              class="d-flex justify-content-between mb-4"
              style="background-color: transparent"
            >
              <section style="min-width: 200px">
                <p
                  style="
                    font-family: 'Arial', 'Tahoma', 'Segoe UI', sans-serif;
                    background-color: transparent;
                    margin-bottom: 40px;
                    font-size: 16px;
                  "
                >
                  الاسم: {{ patientName }}
                </p>
              </section>
            </div>

            <div
              class="d-flex justify-content-between"
              style="background-color: transparent"
            >
              <section style="min-width: 200px">
                <p
                  style="
                    font-family: 'Arial', 'Tahoma', 'Segoe UI', sans-serif;
                    background-color: transparent;
                    font-size: 16px;
                  "
                >
                  التاريخ: {{ currentDate }}
                </p>
              </section>
            </div>
          </div>

          <div
            class="mt-5 pt-4 contact-info"
            style="
              border-top: 1px solid #ddd;
              background-color: transparent;
              padding: 15px 10px;
            "
          >
            <div
              style="
                display: flex;
                justify-content: space-between;
                align-items: flex-start;
                font-family: 'Arial', 'Tahoma', 'Segoe UI', sans-serif;
                background-color: transparent;
                font-size: 14px;
                line-height: 2;
                color: #555;
              "
            >
              <div style="text-align: right; order: 2">
                <p
                  v-if="$brand.email"
                  style="margin: 0; background-color: transparent"
                >
                  📧 Email: {{ $brand.email }}
                </p>
                <p
                  v-if="$brand.phone"
                  style="margin: 0; background-color: transparent"
                >
                  📞 Mobile: {{ $brand.phone
                  }}<span v-if="$brand.phone2"> - {{ $brand.phone2 }}</span>
                </p>
              </div>
              <div style="text-align: left; order: 1">
                <p
                  v-if="$brand.addressAr"
                  style="margin: 0; background-color: transparent"
                >
                  📍 العنوان: {{ $brand.addressAr }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import Watermark from "@/components/common/Watermark.vue";

export default {
  name: "BirthCertificateCommitmentPrint",
  components: {
    Watermark,
  },
  props: {
    patientData: {
      type: Object,
      required: true,
    },
  },
  computed: {
    patientName() {
      return this.patientData?.patient?.name || "";
    },
    currentDate() {
      const now = new Date();
      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, "0");
      const day = String(now.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    },
  },
  methods: {
    async print() {
      const printWindow = window.open("", "_blank");
      const { printContent } = this.$refs;

      // Get watermark image source
      const watermarkImg = printContent.querySelector(".watermark-image");
      const watermarkSrc = watermarkImg ? watermarkImg.src : "";

      // Clone the content and update image sources
      const contentClone = printContent.cloneNode(true);
      const watermarkClone = contentClone.querySelector(".watermark-image");
      if (watermarkClone && watermarkSrc) {
        watermarkClone.src = watermarkSrc;
      }

      printWindow.document.write(`
        <!DOCTYPE html>
        <html dir="rtl">
          <head>
            <title>Birth Certificate Commitment</title>
            <style>
              @page {
                size: A4;
                margin: 20mm;
                @top-left { content: ""; }
                @top-center { content: ""; }
                @top-right { content: ""; }
                @bottom-left { content: ""; }
                @bottom-center { content: ""; }
                @bottom-right { content: ""; }
              }
              body {
                font-family: 'Arial', 'Tahoma', 'Segoe UI', sans-serif;
                margin: 0;
                padding: 0;
                direction: rtl;
                background-color: transparent;
              }
              .print-content {
                position: relative;
              }
              .print-content > section,
              .print-content > div:not(.watermark-wrapper) {
                position: relative;
                z-index: 10 !important;
                background-color: transparent !important;
              }
              .print-content h1,
              .print-content h4 {
                position: relative;
                z-index: 10 !important;
                text-align: center !important;
                background-color: transparent !important;
              }
              .print-content p,
              .print-content span,
              .print-content div,
              .print-content hr,
              .print-content section {
                position: relative;
                z-index: 10 !important;
                background-color: transparent !important;
              }
              .watermark-wrapper {
                position: fixed;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                z-index: 0 !important;
                pointer-events: none;
                display: flex;
                align-items: center;
                justify-content: center;
              }
              .watermark-image {
                opacity: 0.2;
                max-width: 400px;
                max-height: 400px;
                position: fixed;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
              }
            </style>
          </head>
          <body>
            ${contentClone.innerHTML}
          </body>
        </html>
      `);

      printWindow.document.close();
      printWindow.onload = () => {
        printWindow.print();
        printWindow.close();
      };
    },
  },
};
</script>

<style scoped lang="scss">
.print-container {
  display: none;
}

@media print {
  .print-container {
    display: block;
    position: relative;
    width: 100%;
    min-height: 100vh;
  }

  .print-content {
    position: relative;
    z-index: 1;
  }

  .print-content > section,
  .print-content > div:not(.watermark-wrapper),
  .print-content > h1,
  .print-content > h4,
  .print-content > p {
    position: relative;
    z-index: 10 !important;
    background: transparent;
  }

  .font-modify {
    letter-spacing: normal !important;
  }

  @page {
    size: A4;
    margin: 20mm;
    @top-left {
      content: "";
    }
    @top-center {
      content: "";
    }
    @top-right {
      content: "";
    }
    @bottom-left {
      content: "";
    }
    @bottom-center {
      content: "";
    }
    @bottom-right {
      content: "";
    }
  }
}
</style>
